/* eslint-disable import/no-cycle */
import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import notificationReducer from './notification';
import errorReducer from './error';
import pendingConfirmNotificationReducer from './pendingConfirmNotification';
import userReducer from './user';
import managementCompanyReducer from './managementCompany';
import feedReducer from './feed';
import pastShiftsReducer from './pastShifts';
import globalOverviewReducer from './globalOverview';
import navigateReducer from './navigate';
import flexProfessionalsViewStateReducer from './flexProfessionalsView';
import api from './api';

const store = configureStore({
	reducer: {
		api: api.reducer,
		notification: notificationReducer,
		error: errorReducer,
		user: userReducer,
		managementCompany: managementCompanyReducer,
		pendingConfirmNotification: pendingConfirmNotificationReducer,
		feed: feedReducer,
		pastShifts: pastShiftsReducer,
		navigate: navigateReducer,
		globalOverview: globalOverviewReducer,
		flexProfessionalsView: flexProfessionalsViewStateReducer
	},
	middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(api.middleware)
});

setupListeners(store.dispatch);

export default store;
